module.exports = __webpack_public_path__ + "media/pool_inside.050c7956.mp4";